export const categoryReducer = (state = { category: [], allcategories: [],allunauthcategories:[] }, action) => {
  switch (action.type) {
    case "GET_unauth_CATEGORY":
      return {
        ...state,
        category: action.payload
      };
    case "GET_LISTS_CATEGORIES":
      return {
        ...state,
        allcategories: action.payload
      };
    case "ADD_CATEGORY":
      return {
        ...state,
        category: [...state.category, action.payload],
      };
    case "UPDATE_CATEGORY":
      return {
        ...state,
    category: state.category.map(p =>
      p.id === action.payload.id ? action.payload : p
    )
      };
    case "DELETE_CATEGORY":
      return {
        ...state,
        category: [...state.category, action.payload],
      };
    default:
      return state;
  }
};
